import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  interactive?: boolean;
}

export default function Card({ children, className = '', onClick, interactive = false }: CardProps) {
  return (
    <motion.div
      whileHover={interactive ? { scale: 1.02 } : undefined}
      whileTap={interactive ? { scale: 0.98 } : undefined}
      onClick={onClick}
      className={`bg-card rounded-2xl p-4 border border-border shadow-sm ${
        interactive ? 'cursor-pointer active:scale-98' : ''
      } ${className}`}
    >
      {children}
    </motion.div>
  );
}
